const BOOTSTRAP_PHASE_POST_RENDER = 'post-render'
const BOOTSTRAP_PHASE_PRE_RENDER = 'pre-render'
const BOOTSTRAP_PHASE_COMPLETE = 'complete'
const BOOTSTRAP_PHASE_INIT = 'init'

export {
  BOOTSTRAP_PHASE_POST_RENDER,
  BOOTSTRAP_PHASE_PRE_RENDER,
  BOOTSTRAP_PHASE_COMPLETE,
  BOOTSTRAP_PHASE_INIT,
}
